import RolesSCP from "./RolesSCP";


const LogRenderTypesSCP = [
    { id : 0, name: "Basic", render: (field) => <p>{field.Value}</p>},
    { id : 1, name: "Role", render: (field) => { 
        const role = RolesSCP.find(x => x.id == field.Value);

        return <p style={{color: role?.color}}>{role?.name}</p>;
    } },
];

export default LogRenderTypesSCP;